import React, { useState } from 'react';
import { Plus } from 'lucide-react';

// Secção 8 · Perguntas frequentes (fundo claro)
const FAQS = [
  {
    id: 'faq-acordo',
    question: 'É necessário o acordo de todos os herdeiros para pedir a avaliação?',
    answer: 'Não. Basta que o cabeça-de-casal, ou quem detenha a chave, faculte o acesso ao imóvel. O relatório é único e serve todos os interessados.'
  },
  {
    id: 'faq-custo',
    question: 'Qual o valor do serviço?',
    answer: 'Os honorários dependem da tipologia, da localização, da finalidade e da complexidade documental. Não são uma percentagem do valor apurado. A proposta é enviada no próprio dia, sem compromisso.'
  },
  {
    id: 'faq-prazo',
    question: 'Quanto tempo demora?',
    answer: 'O relatório é entregue em cinco a oito dias úteis após a vistoria, que demora entre trinta e quarenta e cinco minutos.'
  },
  {
    id: 'faq-financas',
    question: 'A avaliação das Finanças não chega?',
    answer: 'Não. O Valor Patrimonial Tributário destina-se à liquidação do IMI e não corresponde ao valor de mercado.'
  },
  {
    id: 'faq-notario',
    question: 'O relatório é aceite pelo notário?',
    answer: 'Sim. O relatório pode ser apresentado no cartório notarial, na conservatória e em tribunal. No crédito bancário, cada banco costuma exigir a avaliação que ele próprio encomenda.'
  },
  {
    id: 'faq-desacordo',
    question: 'Já existem vários herdeiros em desacordo. Ainda faz sentido?',
    answer: 'Sim, e é nesses casos que mais se justifica. A avaliação independente substitui opinião contra opinião por um documento fundamentado e verificável.'
  }
];

export const HerancasFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      className="vjr-faq-section"
      style={{ background: 'var(--cream)' }}
      data-testid="herancas-faq-section"
    >
      <div className="vjr-faq-inner">
        <div className="vjr-faq-intro">
          <div className="valuare-section-label">Esclarecimentos</div>
          <h2 className="valuare-section-title">
            Perguntas<br /><em>frequentes</em>
          </h2>
        </div>
        <div className="vjr-faq-list">
          {FAQS.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.id} className={`vjr-faq-item ${isOpen ? 'open' : ''}`}>
                <button
                  className="vjr-faq-question"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  data-testid={`herancas-faq-question-${index}`}
                >
                  <span>{faq.question}</span>
                  <span className="vjr-faq-icon"><Plus /></span>
                </button>
                <div className="vjr-faq-answer">
                  <div className="vjr-faq-answer-inner">
                    <p data-testid={`herancas-faq-answer-${index}`}>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
